<template>
    <div class="modal fade" id="EndBankAccount" tabindex="-1" aria-hidden="true">
        <div class="modal-dialog modal-lg text-left" role="document">
            <div class="modal-content">
                <div class="modal-header">
                    <div class="col-10 my-auto">
                        <h5 class="modal-title" id="EndBankAccountLabel">End Bank Account</h5>
                    </div>
                    <div class="col-2 my-auto">
                        <span><a class="close"><i class="far fa-times-circle fa-2x" data-dismiss="modal"
                                    id="closeEndAccount" aria-label="Close"></i></a></span>
                    </div>
                </div>
                <div class="modal-body">
                    <div class="container-fluid">
                        <div class="row">
                            <div class="col-lg-12">
                                <div class="row mt-3">
                                    <div class="col-sm-12 text-center">
                                        <p class="font-weight-bold">Are you sure you want to end this bank account?</p>
                                        <button type="submit" @click="submit()" class="btn btn-hc pad w-25 mb-3"
                                            :disabled="submitStatus === 'PENDING'">Yes</button>
                                        <button type="submit" class="btn btn-hc pad w-25 mb-3 ml-4" data-dismiss="modal"
                                             aria-label="Close">No</button>
                                    </div>
                                </div>
                                <hr>
                                <div class="row" v-if="account">
                                    <div class="col-sm-10 col-lg-9">
                                        <div class="row">
                                            <div class="col-lg-12">
                                                <div class="row mt-4">
                                                    <div class="col-sm-12">
                                                        <div class="row mt-3">
                                                            <div class="col-sm-4">
                                                                <label>Account name:</label>
                                                            </div>
                                                            <div class="col-sm-8">
                                                                <p class="underline pl-2">{{account.AccountName}}</p>
                                                            </div>
                                                        </div>
                                                        <div class="row mt-3">
                                                            <div class="col-sm-4">
                                                                <label>Account Number:</label>
                                                            </div>
                                                            <div class="col-sm-8">
                                                                <p class="underline pl-2">
                                                                    {{account.MaskedAccountNumber}}</p>
                                                            </div>
                                                        </div>
                                                        <div class="row mt-3">
                                                            <div class="col-sm-4">
                                                                <label>Sort Code:</label>
                                                            </div>
                                                            <div class="col-sm-8">
                                                                <p class="underline pl-2">{{account.MaskedSortCode}}</p>
                                                            </div>
                                                        </div>
                                                        <div class="row mt-3">
                                                            <div class="col-sm-4">
                                                                <label>Reference:</label>
                                                            </div>
                                                            <div class="col-sm-8 align-self-end">
                                                                <p class="underline pl-2">{{account.Reference}}</p>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="col-sm-2 col-lg-3 mt-2 mobile-space-t">
                                        <!-- THIS IS WHERE THE BANK LOGO GOES -->
                                        <!-- <img src="@/assets/img/natwest_logo_lg.png" class="img-fluid mx-auto d-block" alt="Natwest Bank Logo"> -->
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import { required, minLength, maxLength } from "vuelidate/lib/validators";
import Vue from "vue";

export default {
  data() {
    return {
      submitStatus: null,
      notificationClasses: null,
    };
  },
  validations: {
    name: {
      required,
    },
    accNumber: {
      required,
      minLength,
      maxLength,
    },
    sortcode: {
      required,
      minLength,
      maxLength,
    },
  },
  computed: {
    account() {
      return this.$store.state.finances.endBankAccount;
    },
  },
  methods: {
    submit() {
      document.getElementById("closeEndAccount").click();
      this.$http
        .put(
          "https://" +
            Vue.config.honeycomb.ddbot.domain +
            "/api/v1/lodgements/" +
            this.account.Id,
          {
            AccountId: this.account.AccountId,
            EffectiveTo: new Date(), //moment.utc(moment().format('YYYY-MM-DD')).format(),
          },
          {
            withCredentials: true,
          }
        )
        .then(() => {
          this.submitStatus = "OK";
          this.$snotify.success(`Success! Account ended.`);
          this.$store.dispatch("getBankDetails");
        })
        .catch((error) => {
          // Error
          if (error.response) {
            // The request was made and the server responded with a status code
            // that falls out of the range of 2xx
            this.submitStatus = "Error";
            if (error.response.data.MoreInformation.length > 0) {
              error.response.data.MoreInformation.forEach((e) => {
                this.$snotify.error(`${e.Error}`, {
                  timeout: 0,
                  closeOnClick: true,
                });
              });
            } else {
              this.$snotify.error(`${error.response.data.UserDescription}`, {
                timeout: 0,
                closeOnClick: true,
              });
            }
          } else if (error.request) {
            // The request was made but no response was received
            // `error.request` is an instance of XMLHttpRequest in the browser and an instance of
            // http.ClientRequest in node.js
            this.submitStatus = "Error";
            this.$snotify.error(`No response recieved.`, {
              timeout: 0,
              closeOnClick: true,
            });
          } else {
            // Something happened in setting up the request that triggered an Error
            this.submitStatus = "Error";
            this.$snotify.error(`${error.message}`, {
              timeout: 0,
              closeOnClick: true,
            });
          }
        });
    },
  },
};
</script>
